<template>
  <div class="entry-menus-search">
    <div class="entry-menus-search__cells" v-if="searchData.length">
      <div class="entry-menus-search__cell" v-for="item in searchData" :key="item.key">
        <div class="entry-menus-search__label">{{ item | menuLocalName }}</div>
        <div class="entry-menus-search__value">
          <a
            v-for="link in item.search"
            :key="link.key"
            href="javascript:;"
            class="entry-menus-search__link"
            @click="handleClick(link.key)"
          >{{ link | menuLocalName }}</a>
        </div>
      </div>
    </div>
    <div class="entry-menus-search__empty" v-else>
      <a-empty
        :image="image"
        :description="i18nRender('layouts.text.undefined')"
      />
    </div>
  </div>
</template>

<script>
import EmptyPng from '@/assets/empty.png'
import { filterPane } from '@/store/_util/util'
import { i18nRender } from '@/locales'

export default {
  name: 'EntryMenusSearch',
  props: {
    menus: {
      type: Array,
      default () {
        return []
      }
    },
    keyword: {
      type: String,
      default: ''
    },
    currentLang: {
      type: String,
      default: 'zh_CN'
    }
  },
  data () {
    return {
      image: EmptyPng
    }
  },
  computed: {
    searchData () {
      const { menus, keyword, currentLang } = this
      const target = keyword.toLowerCase().trim()
      const searchData = menus.map(item => {
        const childMenus = filterPane(item.childMenus, { lastMenu: 2 })
        const search = childMenus.filter(menu => {
          const menuName = menu.menuName[currentLang] || menu.tab
          return ~menuName.toLowerCase().trim().indexOf(target)
        })
        return search.length && { ...item, search }
      })

      return searchData.filter(item => item)
    }
  },
  methods: {
    i18nRender,
    handleClick (key) {
      this.$emit('click', key)
    }
  }
}
</script>

<style lang="less">
  @namespace: entry-menus-search;

  .@{namespace} {
    height: 100%;
    overflow: auto;

    &__cells {
      padding: 22px;
      font-size: 14px;
      line-height: 2;
    }

    &__cell {
      padding: 22px 0;
      border-top: 1px solid #e8e8e8;
      overflow: hidden;

      &:first-child {
        border-top: none;
      }
    }

    &__label {
      float: left;
      width: 160px;
      padding-left: 8px;
      border-left: 3px solid #5681F4;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &__value {
      display: block;
      overflow: hidden;
    }

    &__link {
      margin-right: 5px;
      padding: 0 8px;
      display: inline-block;
      color: #666666;

      &:hover {
        background: rgba(0,0,0,0.1);
      }
    }
  }

  .@{namespace}__empty {
    position: relative;
  }
</style>
